module.exports = __webpack_public_path__ + "img/19.6d0f5531.jpg";